import Header from "../../Components/Header";
import Footer from "../HomePage/Footer";

const Terms: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />

      <div className="max-w-4xl mx-auto p-6 text-gray-800">
        <h1 className="text-3xl font-bold mb-4">Términos de Servicio</h1>
        <p className="mb-4">
          Bienvenido a <strong>MyBot Service</strong>. Al utilizar nuestros
          servicios de chatbot a través de la API de WhatsApp u otros canales,
          aceptas cumplir con los presentes Términos de Servicio. Por favor, lee
          cuidadosamente este documento antes de usar nuestro servicio.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. Uso del servicio</h2>
        <ul className="list-disc list-inside mb-4">
          <li>
            El servicio de <strong>MyBot Service</strong> está diseñado para
            facilitar la comunicación, gestión de citas y atención básica a
            usuarios mediante WhatsApp.
          </li>
          <li>
            Aceptas utilizar el servicio únicamente para fines legales y de
            acuerdo con estos términos.
          </li>
          <li>
            No está permitido utilizar el chatbot para enviar spam, contenido
            ilegal, difamatorio, fraudulento, ofensivo o que infrinja derechos
            de terceros.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          2. Responsabilidad del usuario
        </h2>
        <p className="mb-4">
          Eres responsable de la veracidad de la información que compartes a
          través del servicio, así como de mantener la confidencialidad de tu
          dispositivo y cuenta de WhatsApp.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          3. Limitación de responsabilidad
        </h2>
        <p className="mb-4">
          <strong>MyBot Service</strong> no se hace responsable de daños
          indirectos, incidentales o consecuentes derivados del uso o la
          imposibilidad de uso del servicio. Nos reservamos el derecho a
          interrumpir temporal o permanentemente el servicio sin previo aviso en
          casos de mantenimiento, mejoras o por razones técnicas.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          4. Propiedad intelectual
        </h2>
        <p className="mb-4">
          Todos los derechos sobre el software, logotipos, marcas y contenidos
          generados por <strong>MyBot Service</strong> pertenecen a sus
          respectivos titulares. El uso del servicio no te otorga ningún derecho
          de propiedad intelectual sobre dichos elementos.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          5. Modificaciones a los términos
        </h2>
        <p className="mb-4">
          Nos reservamos el derecho de modificar estos Términos de Servicio en
          cualquier momento. La versión actualizada se publicará en esta página,
          indicando la fecha de última actualización.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          6. Ley aplicable y jurisdicción
        </h2>
        <p className="mb-4">
          Estos términos se rigen por las leyes de Colombia. En caso de disputa,
          las partes se someten a la jurisdicción de los tribunales de la ciudad
          de Cali.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">7. Contacto</h2>
        <p className="mb-4">
          Si tienes preguntas sobre estos términos, puedes contactarnos al
          correo: 
        </p>
        <p className="mb-1">
          <a
            href="mailto:mybotserviceco@gmail.com"
            className="text-blue-600 underline"
          >
            mybotserviceco@gmail.com
          </a>
        </p>

        <p className="text-sm text-gray-500 mt-8">
          Última actualización: Ago 24, 2025
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default Terms;
